import _ from "lodash";

import { getLabelValue } from "../../../modules/utils";
import { AGGREGATE_TYPE_DESCRIPTION_MAP } from "../../../modules/constants";

export const getResolvedLabelForChildren = ({ label, language, t }) => {
  if (!label) return "";

  if (_.isObject(label)) {
    return getLabelValue({ label, language, t });
  }

  const keys = _.split(_.trim(label || ""), " ");
  return _.join(
    _.map(keys, key => t(key)),
    " "
  );
};

export const getDescriptionByItemId = ({ rowItem, t }) => {
  const configDescriptionKey = _.get(rowItem, "descriptionKey", "");
  if (configDescriptionKey) {
    return t(configDescriptionKey);
  }

  const configDescription = _.get(rowItem, "description", "");
  if (configDescription) {
    return configDescription;
  }
  return "";
};

const getFirstGradingPeriodId = ({ transcriptConfiguration }) => {
  const gradingPeriodWise = _.get(
    transcriptConfiguration,
    "gradeScales.gradingPeriodWise",
    {}
  );
  return _.head(_.keys(gradingPeriodWise));
};

const getYearAggregateLabel = ({
  transcriptConfiguration,
  gradeScaleId,
  t,
}) => {
  const viewType = _.get(transcriptConfiguration, "gradeScales.viewType", "");
  const firstGradingPeriodId = getFirstGradingPeriodId({
    transcriptConfiguration,
  });

  const label =
    viewType === "GRADING_PERIOD_WISE"
      ? _.get(
          transcriptConfiguration,
          `gradeScales.gradingPeriodWise.${firstGradingPeriodId}.config.${gradeScaleId}.label`,
          {}
        )
      : _.get(
          transcriptConfiguration,
          `gradeScales.config.${gradeScaleId}.label`,
          {}
        );

  const localizedKey = _.get(label, "localizedKey", "");
  if (localizedKey) {
    return t(localizedKey);
  }

  return _.get(label, "defaultValue", "");
};

export const getYearAggregateDescription = ({
  itemId,
  transcriptConfiguration,
  t,
}) => {
  const [, gradeScaleId, aggregateType] = _.split(itemId, "=>");

  const descriptionKey = _.get(
    AGGREGATE_TYPE_DESCRIPTION_MAP,
    aggregateType,
    AGGREGATE_TYPE_DESCRIPTION_MAP.AVERAGE
  );

  const label = getYearAggregateLabel({
    transcriptConfiguration,
    gradeScaleId,
    t,
  });

  return t(descriptionKey, { label });
};

export const createColumnItem = ({
  itemId,
  itemConfig,
  itemMeta,
  idPrefix = "",
  language,
  t,
  gradeScaleDescription = "",
  isManageColumnItem = false,
}) => {
  const label = _.get(itemConfig, "label", { localizedKey: itemId });

  const description =
    itemId === "OVERALL_CREDITS"
      ? t("transcript:sum_of_credits_across_grading_periods_for_each_subject")
      : gradeScaleDescription;

  return {
    id: idPrefix ? `${idPrefix}_${itemId}` : itemId,
    content: getLabelValue({ label, language, t }),
    label,
    isEnabled: _.get(itemConfig, "isEnabled", false),
    isCheckable: _.get(itemMeta, "isCheckable", true),
    isLabelEditable: _.get(itemMeta, "isLabelEditable", true),
    isManageColumnItem,
    description,
  };
};

export const resolveSelectableKeyForItemId = ({
  itemId,
  gradingPeriodPrefix,
  transcriptToSourceIdMap,
  selectableKeySet,
}) => {
  if (!itemId) return null;
  if (selectableKeySet.has(itemId)) return itemId;

  const rawId = gradingPeriodPrefix
    ? _.replace(itemId, gradingPeriodPrefix, "")
    : itemId;
  const mappedSourceRawId = _.get(transcriptToSourceIdMap, rawId);
  if (!mappedSourceRawId) return null;

  const mappedKey = gradingPeriodPrefix
    ? `${gradingPeriodPrefix}${mappedSourceRawId}`
    : mappedSourceRawId;

  return selectableKeySet.has(mappedKey) ? mappedKey : null;
};
